module.exports = __webpack_public_path__ + "static/media/power_performance_comparative_per_wtg.046f912b.svg";